module.exports = __webpack_public_path__ + "icons/icon-sync.d84bcb87.svg";